module.exports = __webpack_public_path__ + "static/media/tuto-2.68e378ff.jpg";